export default __webpack_public_path__ + "static/media/118.dda791e5.png";